<template>
  <div>
    <div class="uk-flex uk-flex-column uk-margin uk-container" >

      <div v-for="(post, index) in posts" 
            class="uk-card uk-card-default uk-card-body widget">
          
            <h2 class="widget-title">
              <router-link :to="'/news/' + post.slug" v-html="post.title">
              </router-link>
            </h2>

            <div class="widget-data">
              <span uk-icon="icon: calendar"></span> {{post.date}} 
            </div>

            <div class="widget-content" v-html="post.content"></div>
      </div>

    </div>

  </div>
</template>



<script>
//import { AUTH_LOGOUT } from "@/store/actions/auth.js";
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import axios from "axios";
import { settings } from "@/settings";

let API_SERVER = settings.API_SERVER;

export default {
  name: "Blog",
  metaInfo() {
    return {
      title: this.page.title,
      meta: [
        { name: 'description', content: this.page.title,'vmid': 'og:image' },
        { name: 'og:image', content: this.page.featimage, 'vmid': 'og:image' },
      ]
    }
  },
  data: function () {
    return {
    posts: [],
    page: {title: "news",featimage:"",content:"",permalink:""},
  }},
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
    getPosts() {
      var _vm = this;
        axios
          .get(API_SERVER + '/_/items/news?limit=10&sort=-date')
          .then(response => {
            this.posts = response.data.data;
            //_vm.$emit('updateHead');
        });
    }
  },
  mounted: function () {
    //console.log("mounted");
    //this.loadWebWidgets();
  },
  created() {
      this.getPosts()
  }
};
</script>
